import styled from "styled-components"

import { COLOR } from "ggx-componentlibrary/design/color/color.constants"

import { Row } from '../navigation.component.styles'

const EcommerceIntegrationRow = styled(Row)`
  svg {
    path {
      fill: ${COLOR.GREY_DARK};
    }
  }

  ${(props) => !props.$isActive && `
    :hover {
      svg {
        path {
          fill: ${COLOR.BLUE_MEDIUM};
        }
      }
    }
  `}
`

export { EcommerceIntegrationRow }